"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _chevronLeft = _interopRequireDefault(require("@spothero/icons/chevron-left"));

var _times = _interopRequireDefault(require("@spothero/icons/times"));

var _dom = _interopRequireDefault(require("@spothero/utils/dom"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Portal = _interopRequireDefault(require("../Portal/Portal"));

var Modal =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Modal, _PureComponent);

  function Modal(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Modal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Modal).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onCloseClick", function (evt) {
      if (_this._isAnimating) {
        return;
      }

      var onCloseClick = _this.props.onCloseClick;

      _this.hide();

      if (onCloseClick) {
        onCloseClick();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onShimClick", function (evt) {
      var _this$props = _this.props,
          useShim = _this$props.useShim,
          closeOnShimClick = _this$props.closeOnShimClick;

      if (useShim && closeOnShimClick && _dom.default.hasClass(evt.target, 'Modal-wrapper')) {
        _this._onCloseClick();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_onBackClick", function (evt) {
      _this.props.onRemoveIndex();
    });
    var _this$props2 = _this.props,
        width = _this$props2.width,
        title = _this$props2.title,
        onBeforeFirstRender = _this$props2.onBeforeFirstRender;
    _this._isDynamicWidth = (0, _isNumber.default)(width) || (0, _indexOf.default)(width).call(width, '%') > 0;
    _this._isAnimating = false;
    _this._isTitleString = title ? (0, _isString.default)(title) : false;
    _this._childHistory = [];

    if (onBeforeFirstRender) {
      onBeforeFirstRender();
    }

    return _this;
  }

  (0, _createClass2.default)(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var width = this.props.width;
      (0, _setTimeout2.default)(function () {
        // if ModalContent throws an error then the container will not be defined
        if (!_this2._container) {
          return;
        }

        if (_this2._isDynamicWidth) {
          var newWidth = (0, _isNumber.default)(width) ? "".concat(width, "px") // numerical width, set accordingly
          : width; // percentage width, retain and set

          _dom.default.addClass(_this2._container, 'Modal-container-custom');

          _this2._container.style.width = newWidth;
        }

        _this2._show();
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _dom.default.removeClass('html', 'Modal-open');
    }
  }, {
    key: "_show",
    value: function _show() {
      var _this3 = this;

      var _this$props3 = this.props,
          useShim = _this$props3.useShim,
          renderInBody = _this$props3.renderInBody,
          onShown = _this$props3.onShown,
          animateOnShow = _this$props3.animateOnShow;
      var node = useShim ? this._modal : this._container;
      var showClass = useShim ? 'Modal-showing' : 'Modal-container-showing';

      _dom.default.addClass(node, showClass);

      if (renderInBody) {
        _dom.default.addClass('html', 'Modal-open');
      }

      if (!useShim) {
        _dom.default.addClass(this._modal, 'Modal-no-shim');
      }

      if (animateOnShow) {
        var _context;

        this._isAnimating = true;
        (0, _bind.default)(_context = window.transitionEnd(node)).call(_context, function () {
          window.transitionEnd(node).unbind();

          if (onShown) {
            onShown();
          }

          _this3._isAnimating = false;
        });
      } else {
        if (onShown) {
          onShown();
        }
      }
    }
  }, {
    key: "_renderModal",
    value: function _renderModal() {
      var _this4 = this;

      var _this$props4 = this.props,
          className = _this$props4.className,
          renderInBody = _this$props4.renderInBody,
          useShim = _this$props4.useShim,
          title = _this$props4.title,
          showClose = _this$props4.showClose,
          children = _this$props4.children,
          width = _this$props4.width,
          animateOnShow = _this$props4.animateOnShow,
          activeContentIndex = _this$props4.activeContentIndex;
      var classes = (0, _classnames.default)('Modal', {
        'Modal-inline': !renderInBody
      }, {
        'Modal-animated': animateOnShow
      }, {
        'Modal-showing': useShim && !animateOnShow
      }, className);
      var containerClasses = (0, _classnames.default)('Modal-container', (0, _defineProperty2.default)({}, "Modal-container-".concat(width), !this._isDynamicWidth), {
        'Modal-container-animated': animateOnShow
      }, {
        'Modal-container-showing': !useShim && !animateOnShow
      });
      return _react.default.createElement("div", {
        ref: function ref(node) {
          _this4._modal = node;
        },
        className: classes
      }, useShim && _react.default.createElement("div", {
        className: "Modal-shim"
      }), _react.default.createElement("div", {
        className: "Modal-wrapper",
        onClick: this._onShimClick
      }, _react.default.createElement("div", {
        ref: function ref(node) {
          _this4._container = node;
        },
        className: containerClasses
      }, title && _react.default.createElement("div", {
        className: "Modal-title"
      }, this._isTitleString ? _react.default.createElement("h1", null, title) : title), _react.default.createElement("div", {
        className: "Modal-ctas"
      }, showClose && _react.default.createElement(_Button.default, {
        className: "Modal-close",
        onClick: this._onCloseClick
      }, _react.default.createElement(_times.default, null)), activeContentIndex > 0 && _react.default.createElement(_Button.default, {
        className: "Modal-back",
        onClick: this._onBackClick
      }, _react.default.createElement(_chevronLeft.default, null))), children)));
    }
    /**
     * Hides the Modal programmatically.
     *
     * @public
     * @param {*} args - The arguments to pass to the onHidden callback in cases where you may need access to something not available in Modal itself.
     * @returns {void}
     */

  }, {
    key: "hide",
    value: function hide() {
      var _context2,
          _this5 = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      this._isAnimating = true;
      var _this$props5 = this.props,
          useShim = _this$props5.useShim,
          renderInBody = _this$props5.renderInBody,
          onHidden = _this$props5.onHidden,
          animateOnShow = _this$props5.animateOnShow;
      var node = useShim ? this._modal : this._container;
      var showClass = useShim ? 'Modal-showing' : 'Modal-container-showing';

      if (!animateOnShow) {
        _dom.default.addClass(node, showClass.replace('showing', 'animated'));
      }

      if (!useShim) {
        _dom.default.removeClass(this._modal, 'Modal-no-shim');
      }

      _dom.default.removeClass(node, showClass);

      if (renderInBody) {
        _dom.default.removeClass('html', 'Modal-open');
      }

      (0, _bind.default)(_context2 = window.transitionEnd(node)).call(_context2, function () {
        window.transitionEnd(node).unbind();
        _this5._isAnimating = false;

        if (!animateOnShow) {
          _dom.default.removeClass(node, "".concat(showClass, "-animated"));
        }

        if (onHidden) {
          onHidden.apply(void 0, args);
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          renderInBody = _this$props6.renderInBody,
          store = _this$props6.store;

      if (renderInBody) {
        return _react.default.createElement(_Portal.default, {
          store: store
        }, this._renderModal());
      } else {
        return this._renderModal();
      }
    }
  }]);
  return Modal;
}(_react.PureComponent);

exports.default = Modal;
(0, _defineProperty2.default)(Modal, "defaultProps", {
  renderInBody: true,
  useShim: true,
  showClose: true,
  width: 'normal',
  activeContentIndex: 0,
  closeOnShimClick: true,
  animateOnShow: true
});